import React from 'react';

const BranchUsersEdit: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-gray-800">Editar usuarios</h1>
      </div>
      <div className="bg-white rounded-lg shadow min-h-[240px]"></div>
    </div>
  );
};

export default BranchUsersEdit;
